import { Component, OnInit, Injector } from '@angular/core';

import { MainService } from 'app/resources/services/index';
import { MoedaUtils } from 'app/resources/utils/moeda-utils';


@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent implements OnInit {

  public isCustomized: boolean;

  constructor(public mainService: MainService) {
    if (location.pathname.replace(/\//g, '')) {
      this.isCustomized = true;
    }
  }

  ngOnInit(): void {
    this.mainService.saldoService.initialize();
  }

  public toggleMenuMobile() {
    $('.header-menu-list-v2').toggleClass('hidden-xs');
  }

  public hideMenuMobile() {
    $('.header-menu-list-v2').addClass('hidden-xs');
  }

  public applyConversion(): number {
    return MoedaUtils.pontoToMoeda(this.mainService.saldoService.saldo.saldoPontos, this.mainService.cartaoService.cartao.indiceMoeda);
  }

}



// WEBPACK FOOTER //
// ./src/app/app-header/app-header.component.ts